<div #cdmPortal class="cv-body-portal">
  <div
    class="cdm-backdrop"
    *ngIf="isOpen && datasetsPanelVisible()"
    (click)="onBackdropClick($event)"
  >
    <div
      class="cdm-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cdm-title"
    >
      <!-- Header -->
      <div class="cdm-header">
        <h2 class="cdm-header__title" id="cdm-title">Explore Datasets</h2>
        <button
          class="cdm-header__close"
          (click)="closeModal.emit()"
          title="Close"
          type="button"
          aria-label="Close"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <!-- Search + filter row -->
      <div class="cdm-search-row">
        <div class="cdm-search">
          <svg class="cdm-search__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            class="cdm-search__input"
            type="text"
            placeholder="Explore datasets"
            [value]="searchQuery()"
            (input)="onSearchInput($event)"
            autocomplete="off"
          />
        </div>

        <!-- Filter funnel toggle -->
        <button
          class="cdm-search-row__icon-btn"
          [class.cdm-search-row__icon-btn--active]="isFilterPanelOpen()"
          (click)="toggleFilterPanel()"
          title="Filter datasets"
          type="button"
          [attr.aria-expanded]="isFilterPanelOpen()"
          aria-controls="cdm-filter-panel"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
        </button>
      </div>

      <!-- Filter panel -->
      <div
        id="cdm-filter-panel"
        class="cdm-filter-panel"
        *ngIf="isFilterPanelOpen()"
        role="region"
        aria-label="Dataset filters"
        [attr.aria-busy]="filtersLoading()"
      >
        <div class="cdm-filter-panel__toolbar">
          <p class="cdm-filter-panel__hint" *ngIf="filtersLoading()">Loading filters…</p>
          <button
            type="button"
            class="cdm-filter-panel__clear-all"
            [disabled]="!hasActiveFilters() || filtersLoading()"
            (click)="clearAllFilters()"
          >
            Clear all
          </button>
        </div>

        <div class="cdm-filter-grid">
          <div class="cdm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="accessPolicy"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="onFilterMultiselectExclusiveChange($event)"
              placeholder="Permissions"
              [disabled]="filtersLoading()"
              [options]="accessPolicyOptionsModel()"
              [selectedItems]="selectedAccessPolicies()"
              (selectedItemsChange)="onAccessPoliciesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cdm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="themes"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="onFilterMultiselectExclusiveChange($event)"
              placeholder="Concepts"
              [disabled]="filtersLoading()"
              [options]="themesOptionsModel()"
              [selectedItems]="selectedThemes()"
              (selectedItemsChange)="onThemesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cdm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="organisation"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="onFilterMultiselectExclusiveChange($event)"
              placeholder="Organisation"
              [disabled]="filtersLoading()"
              [options]="organisationOptionsModel()"
              [selectedItems]="selectedOrganisations()"
              (selectedItemsChange)="onOrganisationsFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cdm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="types"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="onFilterMultiselectExclusiveChange($event)"
              placeholder="Organisation type"
              [disabled]="filtersLoading()"
              [options]="typesOptionsModel()"
              [selectedItems]="selectedTypes()"
              (selectedItemsChange)="onTypesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cdm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="tags"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="onFilterMultiselectExclusiveChange($event)"
              placeholder="Tags"
              [disabled]="filtersLoading()"
              [options]="tagsOptionsModel()"
              [selectedItems]="selectedTags()"
              (selectedItemsChange)="onTagsFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
        </div>
      </div>

      <!-- Dataset list -->
      <div class="cdm-list" [attr.aria-busy]="loading()">

        <!-- Loading skeletons -->
        <ng-container *ngIf="loading()">
          <div class="cdm-item cdm-item--skeleton" *ngFor="let i of [1,2,3,4,5]">
            <div class="cdm-item__row">
              <div class="cdm-item__info">
                <span class="cdm-skeleton cdm-skeleton--name"></span>
                <span class="cdm-skeleton cdm-skeleton--provider"></span>
              </div>
              <div class="cdm-item__actions">
                <span class="cdm-skeleton cdm-skeleton--badge"></span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Error state -->
        <div class="cdm-empty cdm-empty--error" *ngIf="!loading() && error()">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <p>{{ error() }}</p>
        </div>

        <!-- Empty results -->
        <div class="cdm-empty" *ngIf="!loading() && !error() && datasets().length === 0">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <p>No datasets found</p>
        </div>

        <!-- Dataset rows -->
        <ng-container *ngIf="!loading() && !error()">
          <div
            class="cdm-item"
            *ngFor="let dataset of datasets()"
            [class.cdm-item--expanded]="isExpanded(dataset.id)"
          >
            <div class="cdm-item__row">
              <div class="cdm-item__info">
                <span
                  class="cdm-item__name"
                  [attr.title]="dataset.name"
                >{{ dataset.name }}</span>
                <span
                  class="cdm-item__provider"
                  [attr.title]="dataset.provider"
                >{{ dataset.provider }}</span>
              </div>
              <div class="cdm-item__actions">
                <span
                  class="cdm-item__badge cdm-item__badge--{{
                    dataset.access | lowercase
                  }}"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path
                      d="M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20"
                    />
                  </svg>
                  {{ dataset.access }}
                </span>
                <button
                  class="cdm-item__expand-btn"
                  [class.cdm-item__expand-btn--open]="isExpanded(dataset.id)"
                  (click)="toggleExpand(dataset.id)"
                  type="button"
                  [attr.aria-label]="isExpanded(dataset.id) ? 'Collapse' : 'Expand'"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="cdm-item__detail" *ngIf="isExpanded(dataset.id)">
              <div class="cdm-item__detail-actions">
                <div class="cdm-item__detail-btns">
                  <button
                    type="button"
                    class="cdm-item__action-btn"
                    title="Add dataset to charts"
                    [disabled]="isActionBusy(dataset.id)"
                    (click)="onAddDataset(dataset); $event.stopPropagation()"
                  >
                    Add to Charts
                  </button>
                </div>
                <div class="cdm-item__detail-icons">
                  <button
                    class="cdm-item__icon-btn"
                    title="Download"
                    type="button"
                    [disabled]="isActionBusy(dataset.id)"
                    (click)="onDownloadDataset(dataset); $event.stopPropagation()"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </button>
                  <button
                    class="cdm-item__icon-btn"
                    title="Open in new tab"
                    type="button"
                    (click)="openDatasetDetail(dataset.id); $event.stopPropagation()"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                      />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </button>
                </div>
              </div>

              <p
                class="cdm-item__access-msg"
                *ngIf="showsNoAccessMessage(dataset.id)"
              >
                User does not have access to this dataset. Please
                <button
                  type="button"
                  class="cdm-item__access-link"
                  (click)="onRequestAccessClick(dataset.id); $event.stopPropagation()"
                >
                  request access
                </button>
                to download.
              </p>

              <p
                class="cdm-item__access-msg"
                *ngIf="showsFileNotFoundMessage(dataset.id)"
              >
                File not found.
              </p>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

  <lib-canvas-request-access-modal
    [visible]="showRequestAccessModal()"
    [userHasOrganisation]="userHasOrganisation()"
    [organisationName]="organisationName()"
    [closeOnSubmit]="false"
    (visibleChange)="onRequestAccessModalVisibleChange($event)"
    (requestAccessSubmit)="onRequestAccessSubmit($event)"
  ></lib-canvas-request-access-modal>
</div>
